import React from 'react'
import { InfoList, InfoListWrapper } from './MyProfilePageStyled'
import { inject, observer } from 'mobx-react'
import { EmptyText } from '../../components/Common/CellText'

const Contact = props => {
  const { authenticationStore } = props

  const { currentUser } = authenticationStore

  const nullText = <EmptyText>Chưa cập nhật</EmptyText>

  if (!currentUser) return null

  return (
    <InfoListWrapper>
      <InfoList>
        <dt>Quê quán</dt>
        <dd>{currentUser?.other?.hometown || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Nơi ở hiện nay</dt>
        <dd>{currentUser?.address || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Nơi đăng ký HKTT</dt>
        <dd>{currentUser.other?.registration_location || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Điện thoại di động</dt>
        <dd>{currentUser?.phone || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Số máy nội bộ</dt>
        <dd>{currentUser?.home_phone || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Số CMTND</dt>
        <dd>{currentUser?.other?.c_id || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Ngày cấp</dt>
        <dd>{currentUser?.other?.license_date || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Số sổ BHXH</dt>
        <dd>{currentUser?.other?.si_no || nullText}</dd>
      </InfoList>
    </InfoListWrapper>
  )
}

Contact.propTypes = {}

export default inject('authenticationStore')(observer(Contact))
